import { Button, Dialog, useRuntimeEnv, useTranslations } from "@bsm/component";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";

const STORAGE_LAST_SHOWN_AT_KEY = "leave-balance-threshold-last-shown-at";
const LEAVE_BALANCE_THRESHOLD = 25;

export const LeaveBalanceThresholdDialog = () => {
    const { runtimeEnv } = useRuntimeEnv(true);
    const [open, setOpen] = useState(false);

    const [
        DIALOG_TITLE,
        DIALOG_MESSAGE,
        DIALOG_WARNING_MESSAGE,
        DIALOG_CLOSE
    ] = useTranslations(i18n);

    const soldeConge = useMemo(() => {
        const value = (runtimeEnv?.personnel as any)?.congeSolde;
        if (value === undefined || value === null || value === "") {
            return undefined;
        }

        const numericValue = Number(value);
        return Number.isNaN(numericValue) ? undefined : numericValue;
    }, [runtimeEnv?.personnel]);

    const dialogMessage = useMemo(() => {
        return DIALOG_MESSAGE
            .replace("{threshold}", `${LEAVE_BALANCE_THRESHOLD}`)
            .replace("{currentBalance}", `${soldeConge ?? 0}`);
    }, [DIALOG_MESSAGE, soldeConge]);

    useEffect(() => {
        const lastShownAt = window.localStorage.getItem(STORAGE_LAST_SHOWN_AT_KEY);
        const alreadyShownToday = lastShownAt && moment(lastShownAt).isSame(moment(), "day");

        if (
            runtimeEnv?.authenticated &&
            soldeConge !== undefined &&
            soldeConge > LEAVE_BALANCE_THRESHOLD &&
            !alreadyShownToday
        ) {
            window.localStorage.setItem(STORAGE_LAST_SHOWN_AT_KEY, moment().toISOString());
            setOpen(true);
        }
    }, [runtimeEnv?.authenticated, soldeConge]);

    return (
        <Dialog
            data-testid="leave-balance-threshold-dialog"
            open={open}
            title={DIALOG_TITLE}
            onClose={() => setOpen(false)}
        >
            <div className="flex flex-col gap-4">
                <p>{dialogMessage}</p>
                {/* <p>{DIALOG_WARNING_MESSAGE}</p> */}
                <div className="flex justify-end">
                    <Button className="btn-default" onClick={() => setOpen(false)}>
                        {DIALOG_CLOSE}
                    </Button>
                </div>
            </div>
        </Dialog>
    );
};

const i18n = [
    "BSMRH.LeaveBalance.Threshold.Dialog.Title",
    "BSMRH.LeaveBalance.Threshold.Dialog.Message",
    "BSMRH.LeaveBalance.Threshold.Dialog.Warning.Message",
    "std_close"
];
